// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crew-form-container {
    background: #e3f0f7;
    border: 1px solid #577481;
    border-radius: 6px;
    padding: 1rem;
}

.crew-new-member {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 1rem;
}

    .crew-new-member input[type="text"],
    .crew-new-member input[type="date"],
    .crew-new-member select {
        flex: 1 1 140px;
        padding: 6px;
        border-radius: 5px;
        border: 1px solid #ccc;
    }

    .crew-new-member label {
        display: flex;
        align-items: center;
        gap: 4px;
        font-weight: 600;
    }

    .crew-new-member button {
        padding: 8px 12px;
        background: #0061b0;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        flex: 1 1 130px;
    }

.crew-table {
    width: 100%;
    border-collapse: collapse;
}

    .crew-table th,
    .crew-table td {
        border: 1px solid #577481;
        padding: 8px;
        text-align: left;
    }

    .crew-table th {
        background-color: #577481;
        color: white;
    }

.crew-actions {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

    .crew-actions button {
        padding: 8px 16px;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        font-weight: 600;
    }

        .crew-actions button.danger {
            background-color: #dc3545;
            color: white;
        }

        .crew-actions button:not(.danger) {
            background-color: #0061b0;
            color: white;
        }
`, "",{"version":3,"sources":["webpack://./src/pages/demo/forms/CrewForm.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;IAEI;;;QAGI,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,eAAe;IACnB;;AAEJ;IACI,WAAW;IACX,yBAAyB;AAC7B;;IAEI;;QAEI,yBAAyB;QACzB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,YAAY;IAChB;;AAEJ;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;IAEI;QACI,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;QAEI;YACI,yBAAyB;YACzB,YAAY;QAChB;;QAEA;YACI,yBAAyB;YACzB,YAAY;QAChB","sourcesContent":[".crew-form-container {\n    background: #e3f0f7;\n    border: 1px solid #577481;\n    border-radius: 6px;\n    padding: 1rem;\n}\n\n.crew-new-member {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 1rem;\n}\n\n    .crew-new-member input[type=\"text\"],\n    .crew-new-member input[type=\"date\"],\n    .crew-new-member select {\n        flex: 1 1 140px;\n        padding: 6px;\n        border-radius: 5px;\n        border: 1px solid #ccc;\n    }\n\n    .crew-new-member label {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        font-weight: 600;\n    }\n\n    .crew-new-member button {\n        padding: 8px 12px;\n        background: #0061b0;\n        color: white;\n        border: none;\n        border-radius: 5px;\n        cursor: pointer;\n        flex: 1 1 130px;\n    }\n\n.crew-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n    .crew-table th,\n    .crew-table td {\n        border: 1px solid #577481;\n        padding: 8px;\n        text-align: left;\n    }\n\n    .crew-table th {\n        background-color: #577481;\n        color: white;\n    }\n\n.crew-actions {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n}\n\n    .crew-actions button {\n        padding: 8px 16px;\n        border-radius: 5px;\n        border: none;\n        cursor: pointer;\n        font-weight: 600;\n    }\n\n        .crew-actions button.danger {\n            background-color: #dc3545;\n            color: white;\n        }\n\n        .crew-actions button:not(.danger) {\n            background-color: #0061b0;\n            color: white;\n        }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
